import type { Paper } from '../types';
import { formatAuthors } from './authors';

export interface FilterOptions {
    dateFrom?: string;
    dateTo?: string;
    filterQuery?: string;
}

export const filterPapers = (papers: Paper[], options: FilterOptions): Paper[] => {
    const { dateFrom, dateTo, filterQuery } = options;
    const q = filterQuery?.toLowerCase();

    return papers.filter((paper) => {
        // 1. Date Range Filter
        if (dateFrom && paper.publication_date < dateFrom) return false;
        if (dateTo && paper.publication_date > dateTo) return false;

        // 2. Text Search Filter
        if (!q) return true;

        const searchableText = [
            paper.title,
            paper.abstract,
            paper.venue,
            formatAuthors(paper.authorships || []),
            ...(paper.institutions || [])
        ].join(' ').toLowerCase();

        return searchableText.includes(q);
    });
};
